@if (loaded()) {
  <div class="query-badge-container" [ngClass]="{ 'is-pivot': isPivot }">
    <div class="left-section">
      @if (isPivot) {
        <hyperkit-icon
          icon="shuffle"
          size="base"
          color="primary"
          class="pivot-icon"
        >
        </hyperkit-icon>
        <hyperkit-icon
          icon="code"
          size="base"
          color="primary"
          class="code-icon"
        >
        </hyperkit-icon>
      } @else {
        <hyperkit-icon icon="code" size="base" color="primary"> </hyperkit-icon>
      }
      <div class="query-text">
        <hyperkit-typography
          class="endpoint-label"
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{ category }}</hyperkit-typography
        >
      </div>
    </div>
    @if (isPivot) {
      <div class="right-section">
        <div class="original-query">
          <hyperkit-tag
            class="parent-query"
            [mode]="'outline'"
            [closable]="false"
            [textLeft]="'Parent Query'"
            [text]="parentQuery"
          >
          </hyperkit-tag>
        </div>
      </div>
    }
    @if (!isPivot && numPivots > 0) {
      <div class="right-section">
        <div class="pivot-count">
          <hyperkit-tag
            class="parent-query"
            [mode]="'outline'"
            [closable]="false"
            [textLeft]="'Pivot Queries'"
            [text]="numPivots.toString()"
          >
          </hyperkit-tag>
        </div>
      </div>
    }
  </div>
} @else {
  <p>Loading…</p>
}
